import { useTooltip } from "hooks/useTooltip";

export const Skeleton = () => {
    const { tooltipRef } = useTooltip({ title: "Sanskin" });

    return (
        <div className="skeleton-wrapper" ref={tooltipRef}>
            <div className="skeleton">
                <div className="head">
                    <div className="head-hemispheres"></div>
                    <div className="eye-shadow eye-shadow-left"></div>
                    <div className="eye eye-left"></div>
                    <div className="eye-shadow eye-shadow-right"></div>
                    <div className="eye eye-right"></div>
                    <div className="nose"></div>
                    <div className="nose-shadow"></div>
                    <div className="mouth">
                        <div className="teeth teeth-left"></div>
                        <div className="teeth teeth-right"></div>
                    </div>
                </div>
                <div className="below-head-container">
                    <div className="backbone"></div>
                    <div className="body">
                        <div className="body-inner">
                            <div className="main-bone"></div>
                            <div className="shoulder"></div>
                            <div className="rib-cage rib-cage-1"></div>
                            <div className="rib-cage rib-cage-2"></div>
                            <div className="kidney-cover"></div>
                            <div className="kidney kidney-left"></div>
                            <div className="kidney kidney-right"></div>
                            <div className="hand hand-left">
                                <div className="hand-top"></div>
                                <div className="arm"></div>
                                <div className="arm-below-container">
                                    <div className="forearm"></div>
                                    <div className="wrist"></div>
                                    <div className="finger finger-pinky"></div>
                                    <div className="finger finger-thumb"></div>
                                    <div className="finger finger-ring"></div>
                                    <div className="finger finger-index"></div>
                                </div>
                            </div>
                            <div className="hand hand-right">
                                <div className="hand-top"></div>
                                <div className="arm"></div>
                                <div className="arm-below-container">
                                    <div className="forearm"></div>
                                    <div className="wrist"></div>
                                    <div className="finger finger-pinky"></div>
                                    <div className="finger finger-thumb"></div>
                                    <div className="finger finger-ring"></div>
                                    <div className="finger finger-index"></div>
                                </div>
                            </div>
                        </div>
                        <div className="feet-container">
                            <div className="foot foot-left">
                                <div className="thigh"></div>
                                <div className="leg leg-left"></div>
                                <div className="shoe"></div>
                            </div>
                            <div className="foot foot-right">
                                <div className="thigh"></div>
                                <div className="leg leg-right"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="shadow"></div>
            </div>
        </div>
    );
};
